import { render, staticRenderFns } from "./ImageMove.vue?vue&type=template&id=6215df96"
import script from "./ImageMove.vue?vue&type=script&lang=js"
export * from "./ImageMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports